// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36nIr","label":"styles_label__C0TKZ"};